import axios from "axios";

type ValidationErrorResponse = {
  error?: string;
  message?: string;
  details?: Array<{ message?: string }>;
};

export function addressBookErrorMessage(
  error: unknown,
  fallback: string
): string {
  const data = axios.isAxiosError<ValidationErrorResponse>(error)
    ? error.response?.data
    : undefined;
  const detail = data?.details?.find((item) => item.message)?.message;
  return detail ?? data?.message ?? data?.error ?? fallback;
}
